import {createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers'
// import {autoLogin} from "./actions/auth"

const store = createStore(rootReducer, applyMiddleware(thunk))

// store.dispatch(autoLogin()).then(res => {
// }).catch(err => {
// })

export default store
